import { consentGranted, fandomCmpReady } from "./consentGranted";

export const installConsentCallbackQueue = () => {
  const FANDOM_CONSENT_UPDATE = "fandomConsentUpdate";
  const LOG_PREFIX = "[Consent Queue]";

  const isLegacyConsentCallbackQueueInstalled = (
    consentCallbackQueue: ConsentCallbackQueue | LegacyConsentCallbackQueue,
  ): consentCallbackQueue is LegacyConsentCallbackQueue => {
    return (
      !Array.isArray(consentCallbackQueue) && "queue" in consentCallbackQueue
    );
  };

  const run = (
    callback: ConsentCallback["callback"],
    category: ConsentCallback["category"],
  ) => {
    if (consentGranted(category)) {
      callback(window.fandomCmp.consents);
    }
  };

  const flush = () => {
    const queue = isLegacyConsentCallbackQueueInstalled(
      window.consentCallbackQueue,
    )
      ? window.consentCallbackQueue.queue
      : window.consentCallbackQueue;
    console.debug(LOG_PREFIX, "flushing consent callback queue", queue);
    while (queue.length) {
      const { callback, category } = queue.shift()!;
      run(callback, category);
    }
  };

  window.consentCallbackQueue ??= [];

  window.consentCallback = (
    name: ConsentCallback["name"],
    callback: ConsentCallback["callback"],
    category?: ConsentCallback["category"],
  ) => {
    if (!fandomCmpReady()) {
      console.debug(LOG_PREFIX, "not ready, queuing callback", name, category);
      isLegacyConsentCallbackQueueInstalled(window.consentCallbackQueue)
        ? window.consentCallbackQueue.push(name, callback, category)
        : window.consentCallbackQueue.push({ name, callback, category });
      return;
    }

    run(callback, category);
  };

  if (fandomCmpReady()) {
    flush();
  } else {
    const listener = () => {
      if (fandomCmpReady()) {
        flush();
        window.removeEventListener(FANDOM_CONSENT_UPDATE, listener);
      }
    };
    window.addEventListener("fandomConsentUpdate", listener);
  }
};
